import { render } from "./KatmalarButton.vue?vue&type=template&id=e312e4a4&scoped=true"
import script from "./KatmalarButton.vue?vue&type=script&lang=js"
export * from "./KatmalarButton.vue?vue&type=script&lang=js"

import "./KatmalarButton.vue?vue&type=style&index=0&id=e312e4a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e312e4a4"]])

export default __exports__